import { Observable } from '../Observable';
import { createOperatorSubscriber } from './OperatorSubscriber';
import { from } from '../observable/from';
import { noop } from '../util/noop';
export function takeUntil(notifier) {
    return function (source) {
        return new Observable(function (subscriber) {
            from(notifier).subscribe(createOperatorSubscriber(subscriber, function () { return subscriber.complete(); }, noop));
            !subscriber.closed && source.subscribe(subscriber);
        });
    };
}
//# sourceMappingURL=takeUntil.js.map